import React, { useState, useEffect } from 'react';

import './styles.css';

import billServices from '../../../../services/admFin/billServices';
import bankAccountServices from '../../../../services/admFin/bankAccountServices';

import { Dots } from "react-activity";

import Popup from '../../../../components/Popup';
import Input from '../../../../components/Input';
import { FaArrowUp, FaArrowDown, FaFileInvoiceDollar } from 'react-icons/fa';
import companyServices from '../../../../services/admFin/companyServices';
import formatterBR, { formatter } from '../../../../functions/formatCurrency';
import SelectProductsPopUp from './SelectProductsPopUp';
import Notice from '../../../../components/Notice';
import PopupXml from './PopupXml';

export default function PopupNewBill(props) {
    const [auxInfos, setAuxInfos] = useState({});
    const [productsList, setProductsList] = useState([]);
    const [company, setCompany] = useState("");
    const [collaborator, setCollaborator] = useState("");
    const [costCenter, setCostCenter] = useState("");
    const [billsPlan, setBillsPlan] = useState("");
    const [partner, setPartner] = useState("");
    const [description, setDescription] = useState("");
    const [products, setProducts] = useState({});
    const [currency, setCurrency] = useState("");
    const [numberInstallments, setNumberInstallments] = useState(1);
    const [formOfPayment, setFormOfPayment] = useState("");
    const [bankAccount, setBankAccount] = useState("");
    const [note, setNote] = useState("");
    const [fetching, setFetching] = useState(false);
    const [installments, setInstallments] = useState([{
        valor: 0,
        data_venc: "",
        paga: false,
        data_pag: "",
        valor_pago: 0
    }]);
    const [valueProducts, setValueProducts] = useState(0.0);
    const [xml, setXml] = useState("");
    const [identifierRecipe, setIdentifierRecipe] = useState("");

    const [visibility, setVisibility] = useState(false);
    const [visibilityXml, setVisibilityXml] = useState(false);
    const [productsIdx, setProductsIdx] = useState([]);

    useEffect(() => {
        readInfoNewBill();
    }, []);

    useEffect(() => {
        let totalValue = 0;
        for (const key of Object.keys(products)) {
            totalValue += products[key].quantidade * products[key].produto.valor_unitario_comercial;
        }

        setValueProducts(totalValue);

    }, [products]);

    useEffect(() => {
        console.log("Entrei aqui");
        console.log(installments);
        console.log(valueProducts);
        setInstallments(oldArray => {
            const temp = [...oldArray];
            for (const installment of temp) {
                installment.valor = valueProducts / temp.length;
            }
            return temp;
        });
    }, [installments.length, valueProducts]);

    useEffect(() => {
        if (props.data && props.data.id) {
            setCompany(props.data.empresa.nome);
            if (props.data.centro_de_custo)
                setCostCenter(props.data.centro_de_custo.nome);
            if (props.data.colaborador)
                setCollaborator(props.data.colaborador.nome);
            if (props.data.plano_de_contas)
                setBillsPlan(props.data.plano_de_contas.nome);
            setPartner(props.data.parceiro.nome);
            setDescription(props.data.descricao);
            setIdentifierRecipe(props.data.identificadorNota);

            if (props.data.produtos) {
                const tempProducts = {};
                for (const produto in props.data.produto) {
                    const product = { 'produto': produto.produto, 'quantidade': produto.quantidade };
                    tempProducts[produto.produto.id] = product;

                }
                setProducts(tempProducts);
            } else {
                setProducts({});
            }

            setCurrency(props.data.moeda);
            setNumberInstallments(props.data.numero_parcelas);
            setInstallments(props.data.parcelas.filter(obj => obj.paga === false));

            if (props.data.forma_de_pagamento) setFormOfPayment(props.data.forma_de_pagamento.nome);
            else setFormOfPayment("");

            if (props.data.conta_bancaria)
                setBankAccount(`${props.data.conta_bancaria.id}: ${bankAccountServices.formatBankAccount(props.data.conta_bancaria)}`);
            setNote(props.data.obs);
        } else
            cleanStates();
    }, [props.data]);

    useEffect(() => {
        if (auxInfos.produtos) {
            let auxArray = auxInfos.produtos.slice();

            if (props.type === "receber") {
                auxArray = auxArray.filter(item => item.tipo === 0);
            }

            if (costCenter)
                auxArray = auxArray.filter(item => item.centro_de_custo.nome === costCenter);
            if (billsPlan)
                auxArray = auxArray.filter(item => item.plano_de_contas.nome === billsPlan);

            //if (product && !auxArray.find(item => item.nome === product)) setProduct("");
            setProductsList(auxArray);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auxInfos, costCenter, billsPlan, props.type]);

    useEffect(() => {
        if (company && auxInfos.empresas) {
            const temp = auxInfos.empresas.find(empresa => empresa.nome === company);
            if (temp)
                setCurrency(temp.moeda);
        }
    }, [company]);

    /* useEffect(() => {
        let productObj = productsList.find(item => item.nome === product);
        if (product && productObj && (!costCenter || !billsPlan)) {
            if (!costCenter)
                setCostCenter(productObj.centro_de_custo.nome);
            if (!billsPlan)
                setBillsPlan(productObj.plano_de_contas.nome);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product, productsList]); */

    useEffect(() => {
        const tempProducts = {};
        for (const idx of productsIdx) {
            //produto na hashtable
            const product = { 'produto': productsList[idx], 'quantidade': 0 };
            //verifica hashtable anterior
            if (productsList[idx].id in products) {
                product.quantidade = products[productsList[idx].id].quantidade;
            }
            tempProducts[productsList[idx].id] = product;
        }
        console.log(tempProducts);
        setProducts(tempProducts);
    }, [productsIdx]);

    function onBlurNumberInstallments(e) {
        if (props.data.numero_parcelas && numberInstallments < props.data.numero_parcelas_pagas) {
            alert("Não é permitido atualizar a conta com menos parcelas que o número de parcelas já pagas");
            setNumberInstallments(props.data.numero_parcelas)
            setInstallments(props.data.parcelas.filter(obj => obj.paga === false));
            return;
        }
        if (props.data.numero_parcelas) {
            if (numberInstallments - props.data.numero_parcelas_pagas > installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments - props.data.numero_parcelas_pagas > temp.length) {
                        temp.push({
                            valor: 0,
                            data_venc: "",
                            paga: false,
                            data_pag: "",
                            valor_pago: 0
                        });
                    }
                    return temp
                });
            }
            else if (numberInstallments - props.data.numero_parcelas_pagas < installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments - props.data.numero_parcelas_pagas < temp.length) {
                        temp.pop();
                    }
                    return temp;
                });
            }

        }
        else {
            if (numberInstallments > installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments > temp.length) {
                        temp.push({
                            valor: 0,
                            data_venc: "",
                            paga: false,
                            data_pag: "",
                            valor_pago: 0
                        });
                    }
                    return temp
                });
            }
            else if (numberInstallments < installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments < temp.length) {
                        temp.pop();
                    }
                    return temp;
                });
            }
        }
    }

    async function readInfoNewBill() {
        const response = await billServices.getInfoNewBill();
        if (response.status === 200) {

            setAuxInfos(response.data);
        } else
            alert("Erro ao ler informações auxiliares 2, tente novamente!");
    }

    async function createBill() {
        if ((props.type === "pagar" || props.type === "receber") && company && ((props.type === "pagar" && costCenter && billsPlan) || props.type === "receber") && partner && description && numberInstallments && currency && installments.length > 0 && formOfPayment && ((formOfPayment.toLowerCase() !== "dinheiro" && bankAccount) || formOfPayment.toLowerCase() === "dinheiro")) {
            setFetching(true);
            const productsArray = Object.keys(products).map(objId => {
                return {
                    'produto': products[objId].produto.id,
                    'quantidade': products[objId].quantidade,
                    'valor_unidade': products[objId].valor_unidade,
                    'icms': products[objId].icms,
                    'pis': products[objId].pis,
                    'cofins': products[objId].cofins
                };
            })
            let cc = auxInfos.centros_de_custo.find(item => item.nome === costCenter);
            if (cc)
                cc = cc.id;
            else
                cc = null;
            let cp = auxInfos.planos_de_contas.find(item => item.nome === billsPlan);
            if (cp)
                cp = cp.id;
            else
                cp = null;
            const response = await billServices.postBill(
                auxInfos.empresas.find(item => item.nome === company).id,
                collaborator ? auxInfos.colaboradores.find(item => item.nome === collaborator).id : "",
                cc,
                cp,
                auxInfos.parceiros.find(item => item.nome === partner).id,
                description,
                companyServices.moedaTypes.find(obj => obj[1] === currency)[0],
                numberInstallments,
                installments,
                auxInfos.formas_de_pagamento.find(item => item.nome === formOfPayment).id,
                Number(bankAccount.split(":")[0]),
                note,
                props.type === "pagar" ? 0 : 1,
                productsArray,
                false,
                xml,
                identifierRecipe
            );
            setFetching(false);
            if (response.status === 201) {
                if (props.onCreate) props.onCreate();
                props.setVisibility(false);
                cleanStates();
            } else
                alert("Erro ao criar conta, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios");
    }

    async function updateBill() {
        if (company && ((props.type === "pagar" && costCenter && billsPlan) || props.type === "receber") && partner && description && currency && numberInstallments && formOfPayment && ((formOfPayment.toLowerCase() !== "dinheiro" && bankAccount) || formOfPayment.toLowerCase() === "dinheiro")) {
            setFetching(true);
            let cc = auxInfos.centros_de_custo.find(item => item.nome === costCenter);
            if (cc)
                cc = cc.id;
            else
                cc = null;
            let cp = auxInfos.planos_de_contas.find(item => item.nome === billsPlan);
            if (cp)
                cp = cp.id;
            else
                cp = null;
            const response = await billServices.pathcBill(
                props.data.id,
                auxInfos.empresas.find(item => item.nome === company).id,
                collaborator ? auxInfos.colaboradores.find(item => item.nome === collaborator).id : "",
                cc,
                cp,
                auxInfos.parceiros.find(item => item.nome === partner).id,
                description,
                companyServices.moedaTypes.find(obj => obj[1] === currency)[0],
                numberInstallments,
                installments,
                auxInfos.formas_de_pagamento.find(item => item.nome === formOfPayment).id,
                Number(bankAccount.split(":")[0]),
                note,
                identifierRecipe
            );
            setFetching(false);
            if (response.status === 200) {
                if (props.onUpdate) props.onUpdate(response.data);
                props.setVisibility(false);
            } else
                alert("Erro ao editar conta, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios");
    }

    function cleanStates() {
        setCompany("");
        setCostCenter("");
        setCollaborator("");
        setBillsPlan("");
        setPartner("");
        setDescription("");
        setProducts({});
        setCurrency("");
        setNumberInstallments(1);
        setInstallments([{
            valor: 0,
            data_venc: "",
            paga: false,
            data_pag: "",
            valor_pago: 0
        }]);
        setFormOfPayment("");
        setBankAccount("");
        //setDueDate("");
        setNote("");
        setXml("");
        setIdentifierRecipe("");
    }

    return (
        <>
            <Popup
                visibility={props.visibility}
                setVisibility={props.setVisibility}
                icon={props.type === "pagar" || (props.data && props.data.tipo === "Pagar") ?
                    <FaArrowUp />
                    :
                    (props.type === "receber" || (props.data && props.data.tipo === "Receber") ?
                        <FaArrowDown />
                        : <FaFileInvoiceDollar />
                    )
                }
                tittle={`${props.data && props.data.id ? "Editar" : "Nova"} conta ${props.type || (props.data && props.data.tipo) ? ` a ${props.type ? props.type : props.data.tipo.toLowerCase()}` : ""}`}
            >

                {
                    props.type === "pagar" && !(props.data && props.data.id) ?
                        <PopupXml
                            readInfoNewBill={readInfoNewBill}
                            setCompany={setCompany}
                            setPartner={setPartner}
                            setProducts={setProducts}
                            productsList={productsList}
                            setProductsList={setProductsList}
                            setInstallments={setInstallments}
                            xml={xml}
                            setXml={setXml}
                            visibility={visibilityXml}
                            setVisibility={setVisibilityXml}
                            cleanStates={cleanStates}
                        />
                        :
                        null
                }
                
                <form>
                    {
                        props.type === "pagar" && !(props.data && props.data.id) ?
                            <button
                                type='button'
                                onClick={e => setVisibilityXml(true)}
                            >
                                Usar arquivo XML
                            </button>
                            :
                            null
                    }

                    <Input
                        label='Empresa*'
                        type='select'
                        options={auxInfos.empresas ? auxInfos.empresas.map(item => item.nome) : []}
                        id='popup-new-bill-company'
                        onChange={(event) => setCompany(event.target.value)}
                        value={company}
                    />
                    <Input
                        label={`Centro de custo${props.type === "pagar" ? "*" : ""}`}
                        type='select'
                        options={auxInfos.centros_de_custo ? auxInfos.centros_de_custo.map(item => item.nome) : []}
                        id='popup-new-bill-cost-center'
                        onChange={(event) => setCostCenter(event.target.value)}
                        value={costCenter}
                    />
                    <Input
                        label={`Plano de Contas${props.type === "pagar" ? "*" : ""}`}
                        type='select'
                        options={auxInfos.planos_de_contas ? auxInfos.planos_de_contas.map(item => item.nome) : []}
                        id='popup-new-bill-bills-plan'
                        onChange={(event) => setBillsPlan(event.target.value)}
                        value={billsPlan}
                    />
                    <Input
                        label={props.type === "pagar" ? "Fornecedor*" : (props.type === "receber" ? "Cliente*" : "Parceiro*")}
                        type='select'
                        options={auxInfos.parceiros ? auxInfos.parceiros.map(item => item.nome) : []}
                        id='popup-new-bill-partner'
                        onChange={(event) => setPartner(event.target.value)}
                        value={partner}
                    />
                    <Input
                        label='Número da Nota Fiscal'
                        placeholder="Insira o número aqui"
                        id='popup-new-bill-identifierRecipe'
                        onChange={(event) => setIdentifierRecipe(event.target.value.replace(/[^0-9]/g, ''))}
                        value={identifierRecipe}
                    />
                    <Input
                        label='Descrição*'
                        placeholder="Insira uma descrição"
                        type='textarea'
                        id='popup-new-bill-description'
                        onChange={(event) => setDescription(event.target.value)}
                        value={description}
                    />

                    <Input
                        label='Colaborador'
                        type='select'
                        options={company && auxInfos.empresas && auxInfos.empresas.find(item => item.nome === company) ?
                            auxInfos.colaboradores
                                .filter(item => item.empresas.find(empresa_colaborador => empresa_colaborador.nome === company) !== undefined)
                                .map(item => item.nome)
                            : []}
                        id='popup-new-bill-collaborator'
                        onChange={(event) => setCollaborator(event.target.value)}
                        value={collaborator}
                    />
                    <div className="new-bill-popup-button-container">
                        <label className="input-label new-bill-popup-label-products">Produtos</label>
                        {
                            !props.data.id ? (
                                productsList.length === 0 ?
                                    <Notice>Nenhuma Produto para selecionar</Notice>
                                    :
                                    <button className="light-blue" onClick={(e) => {
                                        e.preventDefault();
                                        setVisibility(true);
                                    }}>
                                        Selecione produtos para ligar à conta
                                    </button>
                            )
                                :
                                null
                        }
                    </div>

                    {
                        Object.keys(products).length > 0 && !props.data.id ?
                            Object.keys(products).map((objId, idx) => (
                                <div className='section'>
                                    <h3><b>{products[objId].produto.nome}</b></h3>
                                    <Input
                                        label='Quantidade*'
                                        type="number"
                                        max={props.type === "receber" ? productsList.find(item => item.nome === products[objId].produto.nome).quantidade : undefined}
                                        placeholder="Insira uma quantidade"
                                        id='popup-new-bill-quantity'
                                        onChange={(event) => {
                                            setProducts(oldObj => {
                                                const temp = { ...oldObj };
                                                temp[objId].quantidade = event.target.value;
                                                setProducts(temp);
                                            })
                                        }}
                                        value={products[objId].quantidade}
                                    />
                                </div>

                            ))
                            : null
                    }

                    {/* {
                    auxInfos.produtos && productsList.length ?
                        <div className='section'>
                            <Input
                                label='Produto'
                                type='select'
                                noFilterOptions
                                options={productsList.map(item => item.nome)}
                                id='popup-new-bill-product'
                                onChange={(event) => {
                                    if (product !== "" && event.target.value === "") {
                                        setCostCenter("");
                                        setBillsPlan("");
                                    }
                                    setProduct(event.target.value);
                                }}
                                value={product}
                            />
                            {
                                product && productsList.find(item => item.nome === product) ?
                                    <Input
                                        label='Quantidade*'
                                        type="number"
                                        max={productsList.find(item => item.nome === product).quantidade}
                                        placeholder="Insira uma quantidade"
                                        id='popup-new-bill-quantity'
                                        onChange={(event) => setQuantity(event.target.value)}
                                        value={quantity}
                                    />
                                    : []
                            }
                        </div>
                        : []
                } */}
                    <div className='line'>
                        {/* <Input
                        label='Valor da Parcela*'
                        type="currency"
                        currency={currency}
                        placeholder="Insira um valor"
                        id='popup-new-bill-value'
                        onChange={(event) => setValue(event.target.value)}
                        value={value}
                    /> */}
                        <Input
                            label='Número de Parcelas*'
                            type="number"
                            min={1}
                            max={24}
                            placeholder="Insira um valor"
                            id='popup-new-bill-installments'
                            onChange={(event) => setNumberInstallments(event.target.value)}
                            value={numberInstallments}
                            onBlur={onBlurNumberInstallments}
                        />
                        <Input
                            label='Forma de pag.*'
                            type='select'
                            options={auxInfos.formas_de_pagamento ? auxInfos.formas_de_pagamento.map(item => item.nome) : []}
                            id='popup-new-bill-payment'
                            onChange={(event) => setFormOfPayment(event.target.value)}
                            value={formOfPayment}
                        />
                    </div>
                    <Input
                        label={`Conta bancária${formOfPayment.toLowerCase() !== "dinheiro" ? "*" : ""}`}
                        type='select'
                        options={company && auxInfos.empresas && auxInfos.empresas.find(item => item.nome === company) ?
                            auxInfos.empresas
                                .find(item => item.nome === company).contas_bancarias
                                .map(item => `${item.id}: ${bankAccountServices.formatBankAccount(item)}`)
                            : []
                        }
                        id='popup-new-bill-bank'
                        onChange={(event) => setBankAccount(event.target.value)}
                        value={bankAccount}
                    />
                    {/* <Input
                    label="Vencimento*"
                    type='date'
                    id='popup-new-bill-due-date'
                    onChange={(event) => setDueDate(event.target.value)}
                    value={dueDate}
                /> */}
                    <Input
                        label='Observação'
                        placeholder="Insira uma observação"
                        type='textarea'
                        id='popup-new-bill-note'
                        onChange={(event) => setNote(event.target.value)}
                        value={note}
                    />
                    {
                        numberInstallments ?
                            installments.map((obj, idx) => (
                                <div key={idx}>
                                    <div className='line' >
                                        <Input
                                            label={`Vencimento Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                            type='date'
                                            id='popup-new-bill-due-date'
                                            onChange={(event) => {
                                                setInstallments(oldArray => {
                                                    const temp = [...oldArray];
                                                    temp[idx].data_venc = event.target.value;
                                                    return temp;
                                                })
                                            }}
                                            value={obj.data_venc}
                                        />
                                        <Input
                                            label={`Valor Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                            type="currency"
                                            currency={currency}
                                            placeholder="Insira um valor"
                                            id='popup-new-bill-value'
                                            onChange={(event) => {
                                                setInstallments(oldArray => {
                                                    const temp = [...oldArray];
                                                    temp[idx].valor = event.target.value;
                                                    return temp;
                                                })
                                            }}
                                            value={obj.valor}
                                        />
                                    </div>
                                    <Input
                                        label="Parcela já foi paga?"
                                        type="checkbox"
                                        placeholder="Sim"
                                        id='popup-new-bill-paid'
                                        onChange={(event) => {
                                            setInstallments(oldArray => {
                                                const temp = [...oldArray];
                                                temp[idx].paga = !temp[idx].paga;
                                                return temp;
                                            })
                                        }}
                                        value={obj.paga}
                                        checked={obj.paga}
                                    />
                                    {
                                        obj.paga ?
                                            <div className='line' >
                                                <Input
                                                    label={`Data Pagamento Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                                    type='date'
                                                    id='popup-new-bill-date-payment'
                                                    onChange={(event) => {
                                                        setInstallments(oldArray => {
                                                            const temp = [...oldArray];
                                                            temp[idx].data_pag = event.target.value;
                                                            return temp;
                                                        })
                                                    }}
                                                    value={obj.data_pag}
                                                />
                                                <Input
                                                    label={`Valor Pago Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                                    type="currency"
                                                    currency={currency}
                                                    placeholder="Insira um valor"
                                                    id='popup-new-bill-value-paid'
                                                    onChange={(event) => {
                                                        setInstallments(oldArray => {
                                                            const temp = [...oldArray];
                                                            temp[idx].valor_pago = event.target.value;
                                                            return temp;
                                                        })
                                                    }}
                                                    value={obj.valor_pago}
                                                />
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            ))
                            :
                            null
                    }
                    <button
                        type="button"
                        onClick={() => fetching ? alert("Um envio já está em andamento.") : (props.data && props.data.id ? updateBill() : createBill())}
                    >
                        {
                            fetching ?
                                <Dots />
                                : (props.data && props.data.id ? "Salvar" : "Adicionar")
                        }
                    </button>
                </form>
            </Popup>
            <SelectProductsPopUp
                visibility={visibility}
                setVisibility={setVisibility}
                parentVisibility={props.visibility}
                products={productsList}
                productsSelect={productsIdx}
                setProductsSelect={setProductsIdx}
            />
        </>
    )
}